import Helpers from '@assets/scripts/helpers';

const state = {
	modified: false,
    showCreateNew: false,
	currentConnection: {},
};

export default () => Helpers.cloneObject(state);
